import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {KeycloakApplicationRolesEnum} from 'app/core/modules/rest/user/enums/keycloak-application-roles.enum';

@Component({
    selector: 'app-step-roles',
    templateUrl: './step-roles.component.html',
    styleUrls: ['./step-roles.component.scss']
})
export class StepRolesComponent implements OnChanges {
    @Input() disabledAdminRole: boolean;
    @Input() disabledDoctorRole: boolean;
    @Input() disabledEditorRole: boolean;
    @Input() disabledPatientRole: boolean;
    @Input() selectedRoles: KeycloakApplicationRolesEnum[];
    @Output() closeDialogEvent = new EventEmitter<void>();
    @Output() toggleRoleEvent = new EventEmitter<KeycloakApplicationRolesEnum>();

    patientRoleSelected = false;
    otherRolesSelected = false;

    patientRole = KeycloakApplicationRolesEnum.PATIENT;
    doctorRole = KeycloakApplicationRolesEnum.DOCTOR;
    adminRole = KeycloakApplicationRolesEnum.ADMIN;
    editorRole = KeycloakApplicationRolesEnum.CONTENTEDITOR;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.selectedRoles && this.selectedRoles) {
            if (this.selectedRoles.indexOf(this.patientRole) > -1) {
                this.patientRoleSelected = true;
                this.otherRolesSelected = false;
            } else if (this.selectedRoles.indexOf(this.doctorRole) > -1 || this.selectedRoles.indexOf(this.adminRole) > -1
                || this.selectedRoles.indexOf(this.editorRole) > -1) {
                this.patientRoleSelected = false;
                this.otherRolesSelected = true;
            } else {
                this.patientRoleSelected = false;
                this.otherRolesSelected = false;
            }
        }
    }


    toggleRole(role: KeycloakApplicationRolesEnum): void {
        this.toggleRoleEvent.emit(role);
    }

    onKeyUp(event: any, role: KeycloakApplicationRolesEnum): void {
        if (event.key === 'Enter' || event.code === 'Space') {
            this.toggleRoleEvent.emit(role);
        }
    }
}
